// src/hooks/cities/useGetCitiesForSelect.js
import { useQuery } from "@tanstack/react-query";
import { getCitiesForSelect } from "../../api/apiCities";
import i18next from "i18next";

const useGetCitiesForSelect = (countryId = null) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["citiesForSelect", countryId, i18next.language],
        queryFn: () => getCitiesForSelect(countryId),
    });

    const options = data?.data || [];

    return { options, isLoading, error, refetch };
};

export default useGetCitiesForSelect;